// extracted by mini-css-extract-plugin
export default {"root":"product-ai-images_root__wHZER","container":"product-ai-images_container__oL57t"};